import { Link } from "react-router-dom";
import { ProfileCard } from "@/components/ProfileCard";
import { BrokerageCard } from "@/components/BrokerageCard";
import { PageHeader } from "@/components/PageHeader";
import { useAuth } from "@/auth/AuthProvider";
import { hasCapability } from "@/lib/brokerAuth";

// Broker profile + brokerage (BRK-S019). On the post-login surface, a broker
// sees their own profile (editable by all) and their brokerage (editable only by
// an owner — brokerage:edit). The edit affordance is driven by the capabilities
// from GET /api/broker/me (PMS-S060); the server enforces the same rule.
export function ProfilePage() {
  const { identity } = useAuth();
  const canEditBrokerage = hasCapability(identity, "brokerage:edit");

  return (
    <>
      <PageHeader
        title="Profile & brokerage"
        meta="Manage your contact details and your brokerage's information."
      />
      <section className="flex flex-col gap-6">
        <ProfileCard />
        <BrokerageCard canEdit={canEditBrokerage} />

        <Link to="/portal" className="text-sm text-brk-accent hover:underline">
          ← Back to portal
        </Link>
      </section>
    </>
  );
}
